import React from "react";
import { useParams } from "react-router-dom";

import PageContent from "2g-page-content";

import ZakaznikDetailComponent from "b2b/components/zakaznik-detail/ZakaznikDetail";

export function ZakaznikDetail() {
  const { ico } = useParams();
  return (
    <PageContent>
      <ZakaznikDetailComponent ico={ico} />
    </PageContent>
  );
}

ZakaznikDetail.propTypes = {};

export default React.memo(ZakaznikDetail);
